import { Hint } from '~components/generic/editor/Hint/Hint';
import { PageLayout } from '~components/page/PageLayout';
import EditNavigation from '~extension/navigation/EditNavigation';
import { MenuLockWrapper } from '~extension/navigation/MenuLockWrapper';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import styles from './EditNavigationPage.module.css';

export default function EditNavigationPage() {
  const {
    hlEditNavigation,
    hlEditNavigationLock,
    msgEditNavigationLockedByUser,
    msgEditNavigationLockedByDifferentUser,
    msgEditNavigationWaitingForLock,
  } = useLabels([
    'hlEditNavigation',
    'hlEditNavigationLock',
    'msgEditNavigationLockedByUser',
    'msgEditNavigationLockedByDifferentUser',
    'msgEditNavigationWaitingForLock',
  ]);
  const navigateToDefault = useNavigateToDefault();
  const handleNavigateToDefault = () => navigateToDefault();

  return (
    <MenuLockWrapper onFailure={handleNavigateToDefault}>
      {({ isLockedByUser, isLockedByDifferentUser, msgLockedBy }) => (
        <PageLayout title={hlEditNavigation} className="page--edit-navigation">
          <div className="u-padding-horizontal-xxl">
            <div className="c-view__header u-margin-bottom-md">
              <div className="o-grid o-grid--unpad o-grid--bottom">
                <div className="o-grid__cell o-grid__cell--width-10">
                  <h2>{hlEditNavigation}</h2>
                </div>
              </div>
            </div>
            <div className="c-view__content">
              <Hint>
                <p>
                  <strong>{hlEditNavigationLock}</strong>
                </p>
                {isLockedByUser && <p>{msgEditNavigationLockedByUser}</p>}
                {isLockedByDifferentUser && <p>{msgEditNavigationLockedByDifferentUser}</p>}
                {msgLockedBy && (
                  <p>
                    <em>{msgLockedBy}</em>
                  </p>
                )}
                {!isLockedByDifferentUser && !isLockedByUser && <p>{msgEditNavigationWaitingForLock}</p>}
              </Hint>
            </div>

            <div className="c-view__content">
              <div className={styles.container}>
                <EditNavigation isEditAllowed={isLockedByUser} />
              </div>
            </div>
          </div>
        </PageLayout>
      )}
    </MenuLockWrapper>
  );
}
